import { render } from "./Events.vue?vue&type=template&id=3caafe4e&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"

import "./Events.vue?vue&type=style&index=0&id=3caafe4e&lang=scss"
import "./Events.vue?vue&type=style&index=1&id=3caafe4e&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3caafe4e"]])

export default __exports__